import React from "react";
import laptop from "../assets/serenity.png";
import {
  ChatDots,
  ArrowRight,
  Clock
} from "react-bootstrap-icons";

export default function Services() {
  return (
    <section id="services" className="py-5 section-light servicesSection">
      <div className="container">

        {/* heading */}
        <div className="text-center mb-5">
          <div className="eyebrowWrap justify-content-center">
            <span className="eyebrowLine"></span>
            <p className="aboutEyebrow mb-0">HOW I CAN SUPPORT YOU</p>
            <span className="eyebrowLine"></span>
          </div>

          <h1 className="brand-text-dark mb-2">Services</h1>

          <p className="servicesIntro mb-0">
            Thoughtfully structured sessions designed to support your personal growth.
          </p>
        </div>

        <div className="row g-5 align-items-center">

          {/* LEFT */}
          <div className="col-12 col-lg-7">

            <div className="servicesCard">

              {/* intro */}
              <div className="servicesRow">
                <div className="servicesRowIcon">
                  <Clock />
                </div>

                <p className="servicesText mb-0">
                  Therapy sessions are typically 50 minutes long, with a free one-off
                  30-minute initial consultation to assess your needs and give you
                  the opportunity to speak with me before purchasing sessions.
                </p>
              </div>

              <div className="servicesDivider"></div>

              {/* service */}
              <div className="servicesRow align-items-start">
                <div className="servicesRowIcon">
                  <ChatDots />
                </div>

                <div>
                  <div className="servicesLabel mb-2">
                    Individual therapy
                  </div>

                  <div className="servicesText">
                    One-to-one therapy sessions focused on the main concerns you
                    would like to address. These sessions provide a safe,
                    supportive space for you to continue your journey of
                    self-development.
                  </div>
                </div>
              </div>

              <div className="servicesDivider"></div>

              {/* flow */}
              <div className="servicesFlow">
                <div className="servicesFlowItem">
                  <ArrowRight />
                  <span>Free 30-minute consultation</span>
                </div>

                <div className="servicesFlowItem">
                  <ArrowRight />
                  <span>Ongoing 50-minute sessions</span>
                </div>
              </div>

            </div>

          </div>

          {/* RIGHT IMAGE (no card) */}
          <div className="col-12 col-lg-5 text-center">
            <img
              src={laptop}
              alt="Online therapy session"
              className="servicesImage"
            />
          </div>

        </div>
      </div>
    </section>
  );
}